import bus from './bus'

export const getToken = () => {
  return sessionStorage.getItem('ERPTOKEN') || ''
}

export const setToken = token => {
  token = token || ''
  sessionStorage.setItem('ERPTOKEN', token)
  if (token) {
    bus.$emit('GLOBAL_SET_TOKEN', token)
  }
}



// WEBPACK FOOTER //
// ./src/public/utils/token.js